import callAPI from '../ApiConfig'
import $ from "jquery";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const auditStatuses = async (props) => {

    return await callAPI({
        route: "audit_statuses/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }

    })

}
const addAuditStatus = async (props) => {


    return await callAPI({
        route: "audit_statuses/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })

}
const editAuditStatus = async (props) => {

    return await callAPI({
        route: "audit_statuses/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}
const deleteAuditStatus = async (props) => {


    return await callAPI({
        route: "audit_statuses/" + props?.data?.id,
        method: "delete",
        signal: props?.signal,
        headers: {

        }
    })
}

const getAuditStatusList = async (props) => {

    return await callAPI({
        route: "audit_statuses/",
        method: "get",
        signal: props?.signal,
        params: {
            ...props?.params,
            show_list: 1
        },
        headers: {

        }

    })

}

const auditStatusAPI = {
    auditStatuses: auditStatuses,
    addAuditStatus: addAuditStatus,
    editAuditStatus: editAuditStatus,
    deleteAuditStatus: deleteAuditStatus,
    getAuditStatusList: getAuditStatusList
}
export default auditStatusAPI